import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { getAssignedTeamForOnboarding, type TeamMember } from '@/services/data/teamIntroduction';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

function getInitials(firstName: string | null, lastName: string | null): string {
  const f = firstName?.charAt(0)?.toUpperCase() || '';
  const l = lastName?.charAt(0)?.toUpperCase() || '';
  return f + l || '?';
}

export function TeamAvatarsPanel() {
  const { userId } = useAuthStore();
  const [members, setMembers] = useState<TeamMember[]>([]);

  useEffect(() => {
    if (!userId) return;
    getAssignedTeamForOnboarding(userId).then((result) => {
      if (result.success && result.data) {
        setMembers(result.data);
      }
    });
  }, [userId]);

  return (
    <div className="w-full h-full bg-black flex items-center justify-center px-8">
      <div className="flex items-center -space-x-8">
        {members.map((member, index) => (
          <div
            key={member.role}
            className="relative"
            style={{ zIndex: members.length - index }}
          >
            <Avatar className="h-32 w-32 border-4 border-black shadow-2xl">
              <AvatarImage
                src={member.avatarUrl ?? undefined}
                alt={member.firstName ?? ''}
                className="object-cover"
              />
              <AvatarFallback className="bg-white/10 text-white text-2xl font-semibold">
                {getInitials(member.firstName, member.lastName)}
              </AvatarFallback>
            </Avatar>
          </div>
        ))}
      </div>
    </div>
  );
}
